import { AloftPrice, expected } from '@aloft/toolkit-shared';

import { getMarketTrendsHelpers } from './marketTrends/getMarketTrendsHelpers.js';
import { makeMarketTrendsExportDeps } from './marketTrends/makeMarketTrendsExportDeps.js';
import { Tkv2MarketConditionsExportDeps, Tkv2MarketConditionsState } from './types.js';
import { getCompsWithSaleInfo } from './utils/getCompsWithSaleInfo.js';

type Props = {
  marketConditions: Tkv2MarketConditionsState;
};

export async function makeTkv2MarketConditionsExportDeps({
  marketConditions,
}: Props): Promise<Tkv2MarketConditionsExportDeps> {
  const {
    comps,
    effectiveDate,
    dateOfSaleAdjustment: { selectedMethod, methods },
  } = marketConditions;
  const { marketTrends } = methods ?? {};

  const compsWithSaleInfo = getCompsWithSaleInfo(comps);
  const marketTrendsHelpers =
    marketTrends === undefined
      ? undefined
      : getMarketTrendsHelpers({
          effectiveDate,
          comps: compsWithSaleInfo,
          series: marketTrends.series,
          using: marketTrends.using,
          rounding: AloftPrice.fromDollarLike(100),
        });

  switch (selectedMethod) {
    case 'marketTrends':
      return {
        marketTrends: await makeMarketTrendsExportDeps({
          marketTrendsHelpers: expected(marketTrendsHelpers),
        }),
      };
    default:
      return {};
  }
}
